import React, { useEffect, useState } from "react";
import { Col, Container, Nav, Row } from "react-bootstrap";

import "./Footer.css";

const Footer = () => {
  const [year, setYear] = useState(new Date().getFullYear());

  useEffect(() => {
    const interval = setInterval(
      () => {
        setYear(new Date().getFullYear());
      },
      1000 * 60 * 60 * 24,
    );
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="footer-main">
      <Container className="footer-main-container">
        <Row className="justify-content-center footer-main-menu">
          <Col className="text-center mb-4">
            <Nav.Link className="footer-main-menu-href" href="/">
              Strona główna
            </Nav.Link>
          </Col>
          <Col className="text-center mb-4">
            <Nav.Link className="footer-main-menu-href" href="/offer">
              Oferta
            </Nav.Link>
          </Col>
          <Col className="text-center mb-4">
            <Nav.Link className="footer-main-menu-href" href="/pricing">
              Cennik
            </Nav.Link>
          </Col>
          <Col className="text-center mb-4">
            <Nav.Link className="footer-main-menu-href" href="/about">
              O nas
            </Nav.Link>
          </Col>
          <Col className="text-center mb-4">
            <Nav.Link className="footer-main-menu-href" href="/contact">
              Kontakt
            </Nav.Link>
          </Col>
        </Row>
        <Row className="justify-content-center">
          <Col className="footer-main-address-tel d-flex align-items-center">
            +48 691 166 622
          </Col>
          <Col className="footer-main-address-mail d-flex align-items-center">
            kontakt@strefadlaedukacji.pl
          </Col>
          <Col className="footer-main-address-add">
            <p>dwojka.net Usługi informatyczne</p>
            <p>
              ul. Bzowa 3/2
              <br />
              80-376 Gdańsk
              <br />
              NIP 8471004220
              <br />
              Upoważnienie MEN nr 104/2024
            </p>
          </Col>
        </Row>
        <Row className="justify-content-center">
          <Col className="footer-main-address-footer">
            &copy;2018-{year} dwojka.net Usługi informatyczne
          </Col>
        </Row>
        <Row className="justify-content-center">
          <Col className="text-center">
            <Nav.Link
              className="footer-main-menu-href"
              href="/polityka-prywatnosci"
            >
              Polityka prywatności
            </Nav.Link>
          </Col>
          <Col className="text-center">
            <Nav.Link
              className="footer-main-menu-href"
              href="/polityka-cookies"
            >
              Polityka cookies
            </Nav.Link>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Footer;
